// Keyboard-shortcut hint strip rendered at the bottom of the invoice list
// pane in split-pane mode. Text-only — handlers are wired in a follow-up
// REQ. Mirrors the mockup `03-invoice-list.png` footer strip.
//
// Each item shows the letter chip + label. Letters: j/k navigate, e/p/d/r/s
// trigger row actions, ? opens help (also deferred).
const ITEMS: Array<{ key: string; label: string }> = [
  { key: 'j', label: 'naviguer ↓' },
  { key: 'k', label: 'naviguer ↑' },
  { key: 'e', label: 'accuser' },
  { key: 'p', label: 'traiter' },
  { key: 'd', label: 'litige' },
  { key: 'r', label: 'rejeter' },
  { key: 's', label: 'suspendre' },
  { key: '?', label: 'aide' },
];

export function InvoiceListShortcutsFooter() {
  return (
    <footer
      className="invoice-list__shortcuts"
      data-testid="invoice-list-shortcuts-footer"
      aria-label="Raccourcis clavier"
    >
      {ITEMS.map((item) => (
        <span key={item.key} className="invoice-list__shortcut">
          <kbd>{item.key}</kbd>
          <span className="muted">{item.label}</span>
        </span>
      ))}
    </footer>
  );
}
